<template>
  <span>

    <b-container fluid>
      <b-row class="table-header">
        <b-col cols="12" offset-lg="6" lg="6" offset-xl="9" xl="3">
          <b-form-group>
            <b-form-input
              ref="search"
              v-model="meta.search"
              :disabled="fetching"
              placeholder="Search by name"
              @keyup.native="search"
              @input="searchChanged"/>
          </b-form-group>
        </b-col>
      </b-row>

      <no-data v-if="noData" message="No organizations found..."/>

      <b-table
        v-if="data.length"
        ref="table"
        :hover="rowClickEnabled && !fetching"
        :busy="fetching"
        :responsive="true"
        :items="data"
        :fields="formFields"
        :per-page="Number(meta.per_page)"
        :sort-by="meta.order"
        :sort-desc="meta.desc"
        :no-local-sorting="true"
        @sort-changed="sortChanged"
        @row-clicked="rowClicked">

        <template slot="name" slot-scope="data">
          <span class="name">
            {{ data.value }}
          </span>
        </template>

        <template slot="created" slot-scope="data">
          <div class="no-wrap">
            {{ readableDate(data.value) }}
          </div>
        </template>

        <template slot="actions" slot-scope="data">
          <div v-if="archived" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="restore">
              <b-button
                :disabled="fetching"
                title="restore"
                variant="outline-secondary"
                @click.stop="restore(data.item.id)">
                <i class="fas fa-check"></i>
              </b-button>
            </span>
          </div>
          <div v-else class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="edit">
              <b-button
                :disabled="fetching"
                title="edit"
                variant="outline-secondary"
                @click.stop="edit(data.item.id)">
                <i class="fas fa-cog"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="archive">
              <b-button
                :disabled="fetching"
                title="archive"
                variant="outline-secondary"
                @click.stop="archive(data.item.id)">
                <i class="fas fa-archive"></i>
              </b-button>
            </span>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col cols="12" class="my-1">
          <b-pagination
            v-if="data.length"
            :disabled="fetching"
            :value="Number(meta.current_page)"
            :total-rows="Number(meta.total)"
            :per-page="Number(meta.per_page)"
            @change="pageChanged"/>
        </b-col>
      </b-row>

    </b-container>
  </span>
</template>

<script>
import tableMixin from '../../mixins/admin-table'

export default {
  mixins: [tableMixin],
  data () {
    return {
      editRoute: 'edit-organization',
      formFields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'modules', label: 'Modules', sortable: false },
        { key: 'groups', label: 'Groups', sortable: false },
        { key: 'members', label: 'Members', sortable: false },
        { key: 'created', label: 'Created', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      namespace: 'tenants',
      routeParamName: 'organization',
      rowClickRoute: 'admin-modules'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/organizations/table.vue